const config = {
  googleSiteVerification: 'ekRLBeboUMVHXAXiY4bxqugflTQXeHP4fmHVohFb-v4',
  reCaptchaSiteKey: '6Ld_b-QpAAAAAExzl2YIgMxntE4Wfu8Yhz5-cLOP',
  baseUrl: 'https://www.designstudiouiux.com',
  wp_url: process.env.WP_URL || 'https://www.designstudiouiux.com',
  exclude_form_index: process.env.GATSBY_EXCLUDE_FORM_INDEX === 'true' || false,
  is_production_domain : process.env.GATSBY_IS_PRODUCTION_DOMAIN === 'true' || false,
  analytics_cookie: 'ds_1'
}




module.exports = { config }